const isIE = navigator.userAgent.indexOf("Trident") > -1;

document.addEventListener("DOMContentLoaded", function(){ // Handler when the DOM is fully loaded
    ////////////////////////////////////////////////
    //////////// HIDE MENU ON SCROLL UP ////////////
    ////////////////////////////////////////////////
    let scrollHeight = isIE ? window.pageYOffset : window.scrollY;
    let header = document.querySelector(".page__header");
    if(header != null && header != '') {
        stickHeader(header);

        window.onscroll = function () {
            let pos = isIE ? window.pageYOffset : window.scrollY;
            if (pos > scrollHeight && pos > 0) {
                header.classList.add("page__header--slide-up");
            } else if (pos < scrollHeight || pos <= 0) {
                header.classList.remove("page__header--slide-up");
            }

            scrollHeight = isIE ? window.pageYOffset : window.scrollY;

            stickHeader(header);
        };
    }
});

var stickHeader = function (el) {
    let scrollHeight = isIE ? window.pageYOffset : window.scrollY;

    if(scrollHeight > 0){
        el.classList.add("page__header--sticky");
        document.body.classList.add('sticky-header');
    }else{
        el.classList.remove("page__header--sticky");
        document.body.classList.remove('sticky-header');
    }
};